import React, { useState } from "react";
import CustomPagination from "../CustomPagination/CustomPagination";

const TableRowWithPagination = ({
  rows,
  limit,
  colSpanLength,
  totalCount,
  currentPage: controlledPage,
  onPageChange,
  loading = false,
}) => {
  const isServerSide = typeof onPageChange === "function" && totalCount != null;
  const [internalPage, setInternalPage] = useState(1);
  const currentPage = isServerSide ? controlledPage || 1 : internalPage;

  const indexOfLastRow = currentPage * limit;
  const indexOfFirstRow = indexOfLastRow - limit;
  const currentRows = isServerSide
    ? rows ?? []
    : rows?.slice(indexOfFirstRow, indexOfLastRow) ?? [];

  const totalItems = isServerSide ? totalCount : rows?.length ?? 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / limit));

  const handlePageChange = (pageNumber) => {
    if (isServerSide) {
      onPageChange(pageNumber);
      return;
    }
    setInternalPage(pageNumber);
  };

  return (
    <>
      {currentRows}
      {totalItems > limit ? (
        <tr>
          <td colSpan={colSpanLength}>
            <div className="d-flex align-items-end gap-1 justify-content-center">
              <CustomPagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                lazyLoading={loading}
                totalItems={totalItems}
                itemsPerPage={limit}
              />
            </div>
          </td>
        </tr>
      ) : null}
    </>
  );
};

export default TableRowWithPagination;
